<template>
  <div class="grey lighten-5 fill-height">
    <v-container class="py-0">
      <v-row>
        <v-col
          :cols="$store.state.mobile ? 12 : 8"
          :offset="$store.state.mobile ? 0 : 2"
          :class="$store.state.mobile ? 'pt-0' : ''"
        >
          <v-row align="center">
            <v-col cols="auto">
              <router-link to="/">
                <v-img
                  :src="this.$store.state.webConfig.logo"
                  :width="$store.state.mobile ? 100 : 177"
                  :height="$store.state.mobile ? 36 : 64"
                />
              </router-link>
            </v-col>
            <v-spacer />
            <v-col cols="auto">
              <v-stepper
                value="3"
                class="grey lighten-5"
              >
                <v-stepper-header>
                  <v-stepper-step
                    step="1"
                    complete
                  >
                    <template v-if="$store.getters.languageGetter === '1'">
                      التسوق
                    </template>
                    <template v-else>
                      Shopping
                    </template>
                  </v-stepper-step>
                  <v-divider />
                  <v-stepper-step
                    step="2"
                    complete
                  >
                    <template v-if="$store.getters.languageGetter === '1'">
                      مكان الامر
                    </template>
                    <template v-else>
                      Place order
                    </template>
                  </v-stepper-step>
                  <v-divider />
                  <v-stepper-step step="3">
                    <template v-if="$store.getters.languageGetter === '1'">
                      مكتمل
                    </template>
                    <template v-else>
                      Completed
                    </template>
                  </v-stepper-step>
                </v-stepper-header>
              </v-stepper>
            </v-col>
          </v-row>
          <v-card
            outlined
            tile
          >
            <v-card-text class="pt-4 text-center primary--text">
              <v-icon
                size="128"
                color="success"
              >
                mdi-check-circle-outline
              </v-icon>
              <div>
                <template v-if="$store.getters.languageGetter === '1'">
                  تهانينا! تم وضع طلبك بنجاح
                </template>
                <template v-else>
                  Congratulations! Your order has been successfully placed
                </template>
              </div>
              <div>
                <template v-if="$store.getters.languageGetter === '1'">
                  رقم الطلب:
                </template>
                <template v-else>
                  Order no.:
                </template><span class="font-medium">{{ order.orderNo }}</span>
              </div>
            </v-card-text>
          </v-card>
          <v-card
            outlined
            tile
            class="mt-4"
          >
            <v-card-title class="font-medium">
              <template v-if="$store.getters.languageGetter === '1'">
                عنوان الشحن
              </template>
              <template v-else>
                Shipping Address
              </template>
            </v-card-title>
            <v-divider />
            <v-card-text>
              <div class="text-h5 font-medium black--text d-flex align-center">
                {{ order.contacter }}
                <span class="ms-auto">{{ order.mobile }}</span>
              </div>
              <div class="d-flex align-center">
                {{ order.addr }}
              </div>
            </v-card-text>
          </v-card>
          <v-card
            outlined
            tile
            class="mt-4"
          >
            <v-card-title class="font-medium">
              <template v-if="$store.getters.languageGetter === '1'">
                طريقة الدفع او السداد
              </template>
              <template v-else>
                Payment method
              </template>
            </v-card-title>
            <v-divider />
            <v-card-text class="pb-0">
              <v-radio-group
                class="mt-0 "
                value="1"
              >
                <div class="d-flex align-center">
                  <v-radio
                    value="1"
                    color="grey"
                  />
                  <div>
                    <v-img
                      :src="require('@/assets/paypal-lg.png')"
                      width="100"
                      class="mb-1"
                    />
                  </div>
                </div>
              </v-radio-group>
            </v-card-text>
          </v-card>
          <v-card
            outlined
            tile
            class="mt-4"
          >
            <v-card-title class="font-medium">
              <template v-if="$store.getters.languageGetter === '1'">
                قائمة المنتجات
              </template>
              <template v-else>
                Products
              </template>
            </v-card-title>
            <v-divider />
            <div v-if="$store.state.mobile">
              <div
                v-for="(item) in order.detail"
                :key="item.id"
              >
                <v-container>
                  <v-row>
                    <v-col
                      cols="4"
                    >
                      <router-link :to="{name: 'GoodsDetail', params: {id: item.goodId}}">
                        <v-img
                          :src="item.specImage ? item.specImage : item.image"
                          aspect-ratio="1"
                          contain
                          class="grey lighten-5"
                        >
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="grey"
                              />
                            </v-row>
                          </template>
                        </v-img>
                      </router-link>
                    </v-col>
                    <v-col>
                      <div class="mb-2 line-break line-height-sm black--text">
                        {{ $store.getters.languageGetter === '1' ? item.goodName : item.goodNameEn }}
                      </div>
                      <div class="grey--text">
                        {{ item.goodNo }}
                      </div>
                      <div class="grey--text">
                        {{ $store.getters.languageGetter === '1' ? item.goodDetailName : item.goodDetailNameEn }}
                      </div>
                      <div class="d-flex align-center justify-space-between">
                        <div class="text-h5 font-medium black--text">
                          ${{ item.price }}
                        </div>
                        x{{ item.buNumber }}
                      </div>
                    </v-col>
                  </v-row>
                </v-container>
                <v-divider />
              </div>
              <div class="pa-4">
                <div v-if="order.memo">
                  <template v-if="$store.getters.languageGetter === '1'">
                    مذكرة:
                  </template>
                  <template v-else>
                    Memo:
                  </template>
                  {{ order.memo }}
                </div>
                <div class="text-h3 font-medium mb-2 d-flex justify-space-between">
                  <span><template v-if="$store.getters.languageGetter === '1'">السعر الإجمالي للبضائع:</template>
                    <template v-else>
                      Grand Total:
                    </template> </span> {{ $store.getters.countryGetter.currency }}{{ order.amount }}
                </div>
                <div>
                  <pay-pal
                    :amount="order.actualAmount"
                    currency="USD"
                    :client="credentials"
                    :button-style="{size: 'medium', shape: 'rect'}"
                    env="development"
                    @payment-completed="paymentCompleted"
                    @payment-cancelled="paymentCancelled"
                  />
                </div>
                <div class="text-center mt-2">
                  <router-link
                    to="/"
                    class="text-decoration-underline body-2"
                  >
                    <template v-if="$store.getters.languageGetter === '1'">
                      مواصلة التسوق
                    </template>
                    <template v-else>
                      Continue Shopping
                    </template><v-icon size="14">
                      mdi-chevron-right
                    </v-icon>
                  </router-link>
                </div>
              </div>
            </div>
            <v-card-text v-else>
              <v-data-table
                :headers="headers"
                :items="order.detail"
                item-key="goodDetailId"
                class="data-table-with-select"
                no-data-text="Nothing here"
                loading-text="Loading..."
                hide-default-footer
                disable-pagination
              >
                <template v-slot:item.item="{item}">
                  <div
                    class="py-3 d-flex"
                    style="max-width:350px"
                  >
                    <div>
                      <v-img
                        :src="item.specImage ? item.specImage : item.image"
                        width="80"
                        height="80"
                        class="grey lighten-5"
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color="grey"
                            />
                          </v-row>
                        </template>
                      </v-img>
                    </div>
                    <div class="ps-3">
                      <div class="mb-2 line-break line-height-sm black--text">
                        {{ $store.getters.languageGetter === '1' ? item.goodName : item.goodNameEn }}
                      </div>
                      <div class="grey--text">
                        {{ item.goodNo }}
                      </div>
                      <div class="grey--text">
                        {{ $store.getters.languageGetter === '1' ? item.goodDetailName : item.goodDetailNameEn }}
                      </div>
                    </div>
                  </div>
                </template>
                <template v-slot:item.price="{item}">
                  ${{ item.price }}
                </template>
                <template v-slot:item.summary="{item}">
                  ${{ (+item.price * +item.goodNumber).toFixed(2) }}
                </template>
                <template v-slot:footer>
                  <v-divider />
                  <div class="py-4 pe-4 d-flex body-1">
                    <div
                      v-if="order.memo"
                      style="width:300px"
                    >
                      <template v-if="$store.getters.languageGetter === '1'">
                        معلومات تصريحات:
                      </template>
                      <template v-else>
                        Remark:
                      </template><span class="grey--text ms-1">{{ order.memo }}</span>
                    </div>
                    <v-spacer />
                    <div class="text-right">
                      <div class="text-h5 font-medium mb-2">
                        <span><template v-if="$store.getters.languageGetter === '1'">السعر الإجمالي للبضائع:</template>
                          <template v-else>
                            Grand Total:
                          </template> </span> {{ $store.getters.countryGetter.currency }}{{ order.amount }}
                      </div>
                      <div>
                        <PayPal
                          :amount="order.actualAmount"
                          currency="USD"
                          :client="credentials"
                          :button-style="{size: 'medium', shape: 'rect'}"
                          env="development"
                          @payment-completed="paymentCompleted"
                          @payment-cancelled="paymentCancelled"
                        />
                      </div>
                      <router-link
                        to="/"
                        class="text-decoration-underline body-2"
                      >
                        <template v-if="$store.getters.languageGetter === '1'">
                          مواصلة التسوق
                        </template>
                        <template v-else>
                          Continue Shopping
                        </template><v-icon size="14">
                          mdi-chevron-right
                        </v-icon>
                      </router-link>
                    </div>
                  </div>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import PayPal from 'vue-paypal-checkout';

export default {
  name: 'PayNow',
  components: {
    PayPal,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      order: {
        actualAmount: '',
      },
      credentials: {
        sandbox: 'AW4ap4sF2EB0SdGs71kxGMU_edUHBq1gUwBtTSLhR5oCyvfMzhP5pqWs8BCG64aEDi-U1BsKBY_4ycHv',
        production: 'Af0nU4EiDcvjRLXjYKs6oO_n_s6b_OD7O9z2rjyA3hX8SQoT00_N0qLLkMNfmyJ553Y27PigbW-qgG-z',
      },
      submitting: false,
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.$store.getters.languageGetter === '1' ? 'بند' : 'Item',
          align: 'start',
          sortable: false,
          value: 'goods',
          class: 'text-h6 black--text grey lighten-4',
        },
        {
          align: 'center',
          text: this.$store.getters.languageGetter === '1' ? 'سعر' : 'Price',
          value: 'price',
          sortable: true,
          class: 'text-h6 black--text grey lighten-4',
        },
        {
          align: 'center',
          text: this.$store.getters.languageGetter === '1' ? 'كمية' : 'Quantity',
          value: 'goodNumber',
          class: 'text-h6 black--text grey lighten-4',
          sortable: true,
        },
        {
          align: 'center',
          text: this.$store.getters.languageGetter === '1' ? 'كمية' : 'Amount',
          value: 'summary',
          class: 'text-h6 black--text grey lighten-4',
          sortable: false,
        },
      ];
    },
  },
  created() {
    this.loadPageData();
  },
  methods: {
    ...mapActions('center', ['getOrderDetailAsync']),
    ...mapActions('cart', ['payNowAsync']),
    loadPageData() {
      this.$store.commit('SET_MINI_LOADING');
      this.getOrderDetailAsync({ id: this.id }).then((res) => {
        this.order = res;
      }).finally(() => {
        this.$store.commit('SET_MINI_LOADING');
      });
    },
    // submitForm() {
    //   this.submitting = true;
    // },
    // paymentAuthorized(data) {
    //   console.log('函数: paymentAuthorized -> data', data);
    // },
    paymentCompleted(data) {
      const params = {
        orderId: this.order.id,
        buyerId: this.$store.state.user.id,
        orderNo: this.order.orderNo,
        amount: this.order.actualAmount,
        createUserName: data.payer.payer_info.email,
        createTime: data.create_time,
        paypalId: data.id,
      };
      this.$store.commit('SET_MINI_LOADING');
      this.payNowAsync(params).then(() => {
        this.$router.replace({ name: 'UserOrderDetail', params: { id: this.order.id } });
      }).finally(() => {
        this.$store.commit('SET_MINI_LOADING');
      });
    },
    paymentCancelled() {
      this.$store.commit(
        'TOGGLE_SNACKBAR',
        {
          type: 'error',
          text: 'Payment Cancelled',
        },
        { root: true },
      );
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
